module.exports = __webpack_public_path__ + "img/glass-no-laminated.983e622.svg";